import { ReturnsLineItem as ModelsLineItem } from '@itsrever/rever-api'
import ProductPreview from '@/components/ProductPreview'
import { useTranslate } from '@/hooks'

interface BlockedFromReturnProductCardProps {
    product: ModelsLineItem
}

export const BlockedFromReturnProductCard: React.FC<
    BlockedFromReturnProductCardProps
> = ({ product }) => {
    const { translate } = useTranslate()

    return (
        <div className="flex flex-wrap items-end justify-between gap-4 rounded-lg bg-white p-2">
            <ProductPreview product={product} disabled />
            <p className="ml-auto w-fit max-w-96 shrink-0 rounded-xl border border-solid border-yellow-500 bg-white px-3 py-1 text-right text-xs text-yellow-500">
                {translate('item_selection_reason_multilabel')}
            </p>
        </div>
    )
}
